/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Not_StartedInputs */

const cs_enum_not_started = /** @type {(inputs: Enum_Not_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nezačato`)
};

const en_enum_not_started = /** @type {(inputs: Enum_Not_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not started`)
};

/**
* | output |
* | --- |
* | "Not started" |
*
* @param {Enum_Not_StartedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_not_started = /** @type {((inputs?: Enum_Not_StartedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Not_StartedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_not_started(inputs)
	return cs_enum_not_started(inputs)
});